<template>
  <div class="goods">
    <router-link tag="div" :to="{name:'goodsDetail',query:{id:goods.products_id}}" class="imgbox">
      <img :src="goods.products_pic" alt />
    </router-link>
    <div class="goodsInfor">
      <router-link tag="h5" :to="{name:'goodsDetail',query:{id:goods.products_id}}">{{ goods.products_title }}</router-link>
      <router-link tag="span" :to="{name:'goodsDetail',query:{id:goods.products_id}}" class="specs">{{ goods.products_sku_title }}</router-link >
      <div class="price">
        <span class="t1" v-if="goods.price">￥{{ goods.price }}</span>
        <!-- <span class="t2" v-if="goods.price_del">￥{{ goods.price_del }}</span> -->
        <router-link tag="span" :to="{ name:'asApply',query:{id:goods.id,products_pic:goods.products_pic,products_title:goods.products_title,products_sku_title:goods.products_sku_title,price:goods.price,price_del:goods.price_del} }" class="t3" v-if="goods.price != 0  &&  goods.type == 1 && goods.orders_service_id == 0 && goods.status > 2 && goods.status <=4" >申请售后</router-link>
         <router-link tag="span" :to="{name:'asDetail',query:{id:goods.orders_service_id}}" class="t3" v-if="goods.orders_service_id != 0 && goods.status > 1 ">有售后</router-link>
         <router-link tag="span" :to="{name:'orderEva',query:{id:goods.id}}" class="t3" v-if="goods.orders_service_id == 0 && goods.status == 4 && !goods.is_evaluate">立即评价</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['goods'],
  data () {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.goods {
  width: 100%;
  padding: 30px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-bottom: 1px;
  .imgbox {
    width: 160px;
    height: 160px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .goodsInfor {
    flex: 1;
    height: 160px;
    overflow: hidden;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h5 {
      font-size: 30px;
      color: #333;
      line-height: 36px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .specs {
      margin-top: 10px;
      flex: 1;
      font-size: 22px;
      color: #666;
    }
    .price {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .t1 {
        font-size: 28px;
        color: #e42129;
        flex: 1;
      }
      .t2 {
        flex: 1;
        margin-left: 12px;
        text-decoration: line-through;
        font-size: 22px;
        color: #999;
        display: inline-block;
      }
      .t3{
        display: block;
        width: 144px;
        height: 45px;
        border: 1Px solid #ccc;
        border-radius: 10px;
        color: #333;
        line-height: 45px;
        text-align: center;
        font-size: 24px;
        margin-left: 8px;
      }
    }
  }
}
</style>
